<template>
  <v-app>
    <the-app-bar></the-app-bar>

    <v-main style="background-color: rgb(256, 256, 256);">
      <router-view></router-view>
    </v-main>

    <the-message-alert v-bind="alertConfig" v-on:close="$store.dispatch('alert/close')"></the-message-alert>
  </v-app>
</template>

<script>
import TheAppBar from "@/components/TheAppBar";
import TheMessageAlert from "@/components/TheMessageAlert";

export default {
  name: "App",
  components: {
    TheAppBar,
    TheMessageAlert
  },
  data() {
    return {
      fullWidth: 0,
      fullHeight: 0
    };
  },
  computed: {
    alertConfig() {
      return this.$store.state.alert;
    },
    routeName() {
      return this.$route.name;
    },
    outOfWidth() {
      return this.fullWidth > 500;
    }
  },
  watch: {
    fullWidth(val) {
      if (val > 500)
        this.$store.dispatch("alert/open", {
          title: "使用體驗",
          message: "請在手機解析度下使用，以取得最佳用戶體驗",
          type: "info"
        });
    }
  },
  mounted() {
    this.fullWidth = window.innerWidth;
    this.fullHeight = window.innerHeight;

    window.onresize = () => {
      this.fullWidth = window.innerWidth;
      this.fullHeight = window.innerHeight;
    };
  }
};
</script>

<style lang="scss">
html {
  overflow-y: visible;
}

.v-application--wrap {
  background-color: rgb(64, 64, 64);
}
</style>
